export const ImageLogoDefault = require('./logo.svg');
export const ImageLogoGrey = require('./logo-grey.svg');
export const ImageLogoWhite = require('./logo-white.svg');
export const ImageFacebookLogo = require('./facebook-logo.svg');
export const ImageTwitterLogo = require('./twitter-logo.svg');
export const ImageConvenient = require('./ic-convenient.svg');
export const ImageEasy = require('./ic-easy.svg');
export const ImageSecure = require('./ic-secure.svg');
export const ImageTrusted = require('./ic-trusted.svg');
export const ImageFacebookMessenger = require('./facebook-messenger.svg');
export const ImageKaskusMessenger = require('./kaskus-chat.svg');
export const ImageLINEMessenger = require('./line-messenger.svg');
export const ImageTelegramMessenger = require('./telegram.svg');
export const ImageBrokenLink = require('./broken-link.svg');
export const ImageInvoice = require('./invoice.svg');

export const ImageBuy = require('./landing-buy.png');
export const ImageHeader = require('./image-header.png');
export const ImageIconAccountKyc = require('./ic-account-kyc.png');
export const ImageInvoiceOnboardingInvoice = require('./invoice-onboarding-invoice.png');
export const ImageInvoiceOnboardingFree = require('./invoice-onboarding-free.png');
export const ImageInvoiceOnboardingStore = require('./invoice-onboarding-store.png');
export const ImageKycSampleKtp = require('./kyc-sample-ktp.png');
export const ImageKaspayProBanner = require('./kaspay-pro-banner.png');
export const ImageNationalCardScan = require('./ic-national-card-scan.png');
export const ImageNationalCardSelfie = require('./ic-national-card-selfie.png');
export const ImageProfileSampleKtp = require('./profile-sample-ktp.png');
export const ImageReceive = require('./landing-receive.png');
export const ImageTransfer = require('./landing-transfer.png');

export const ImageFreeze = require('./freeze.png');
export const ImageCheckGreen = require('./ic-check-cr-green.png');
export const ImageDisabled = require('./ic-disabled.png');



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/images/index.ts